<script setup lang="ts">
import { withDefaults, defineProps } from 'vue'
interface Props {
  flex?: string
  rightFlex?: string
  title?: string
  appearance?: boolean
}
const props = withDefaults(defineProps<Props>(), { flex: 'flex-col sm:flex-row', title: '', appearance: true })
</script>

<template>
  <div class="flex flex-col simple-card-master-skeleton" :class="[appearance? 'bg-white' : '']">
    <div class="text-[20px] font-bold">
      <slot name="topContent">
        <div class="text-[20px] font-bold">
          {{ props.title }}
        </div>
      </slot>
    </div>
    <div class="flex flex-col-reverse gap-[24px]" :class="[flex]">
      <div class="flex sm:grow items-start item-box-left">
        <slot name="leftContent"></slot>
      </div>
      <div
        :class="[rightFlex]"
        class="flex grow sm:grow-0 flex-col content-center items-center justify-center self-stretch item-box-right"
      >
        <slot name="rightContent"></slot>
      </div>
    </div>
    <slot name="tableContent"></slot>
  </div>
</template>

<style scoped>
@import '@/assets/algo-css/containers/topcontentcontainersver1.css';
</style>
